<template lang="html">
    <div id="page__lathings" class="center-panel" v-bind:loading="progress">
        <md-content class="md-elevation-1" md-theme="white">
            <DoomPricesMenu></DoomPricesMenu>
            <sort-table
                v-bind:columns="tableColumns" v-model="prices" @refresh="getPrices" v-bind:per-page="perPage" 
                v-bind:total="pricesAmount" link table-id="doomprices" ref="table" v-on:create="addPrice" tableHeight="calc(100% - 48px)"
            >
                <template slot="city" slot-scope="scope">
                    <span class="no-breack-words"> {{ scope.item.city ? scope.item.city.name : 'Не установлен' }} </span>
                </template>
                <template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" danger-light rounded v-on:click.stop.prevent="onRemove(scope.item.id)"></z-icon-button>
                </template>
            </sort-table>
        </md-content>
    </div>
</template>

<script>
    import DoomPricesMenu from './DoomPricesMenu.vue';
    import SortTable from '@/components/SortTable';
    import ZIconButton from '@/components/ZIconButton.vue';
    export default {
        components: { SortTable, ZIconButton, DoomPricesMenu },
        data() {
            return {
                perPage: 50,
                tableColumns: [
                    { label: 'ID', field: 'id', sortable: true },
                    { label: 'Город', field: 'city' },
                    { label: 'Цена', field: 'price' },
                    { label: 'Мин. объём', field: 'volume_min' },
                    { label: 'Мин. цена', field: 'price_min' },
                    { label: '', field: 'actions' },
                ],
            }
        },
        computed: {
            /**
             * список цен
             */
            prices() {
                return this.$store.state.cost.doom_prices.map(price => {
                    price.routerLink = {name: 'DoomPrice', params: {id: price.id}, query: this.$route.query};
                    return price;
                });
            },
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['get-lathings-list'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
            /**
             * Количество цен
             */
            pricesAmount() {
                return this.$store.state.cost.doom_prices_amount
            }
        },
        created() {
            this.$store.commit('setTitle', 'Стоимость обрешетки');
        },
        methods: {
            /**
             * Добавление цены
             */
            addPrice() {
                this.$router.push({ name: 'DoomPrice', params: { id: 'new' } });
            },
            /**
             * Получение цен
             */
            getPrices(page, count, orderBy, orderType) {
                this.$store.commit('showProgressBar', 'get-lathings-list');
                this.$store.dispatch('cost/getDoomPrices', {
                    page: page, order_by: orderBy, order_type: orderType, count: count
                }).finally(() => this.$store.commit('hideProgressBar', 'get-lathings-list'));
            },
            /**
             * Удаление цены
             */
            removeLathings(id) {
                if (!id) return;
                this.$store.commit('showProgressBar', 'get-lathings-list');
                this.$store.dispatch('cost/deleteDoomPrice', id)
                    .then(() => this.$root.$emit('refresh-table', 'doomprices'))
                    .finally(() => this.$store.commit('hideProgressBar', 'get-lathings-list'));
            },
            /**
             * Модальное окно с удалением цены на обрешетку
             */
            onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении цены?', 'Действие необратимо!',
                    () => this.removeLathings(id)
                );
            },
        },
    }
</script>


// WEBPACK FOOTER //
// DoomPrices.vue?5c10c516